import { useLocation } from "react-router-dom";

/**
 * Есть ли куда возвращаться внутри приложения.
 *
 * Кнопка «Открыть заказ» в уведомлении бота открывает Mini App сразу на
 * /orders/<номер>. История при этом пустая, navigate(-1) делать нечего — и
 * нативная стрелка Telegram выглядела бы рабочей, не реагируя на нажатие.
 *
 * Признак — ключ записи истории: react-router проставляет свой ключ только
 * записям, которые сам добавил; у точки входа его нет, и роутер отдаёт
 * "default" — «сюда пришли снаружи, а не переходом внутри приложения».
 */
export function useCanGoBack(): boolean {
  return useLocation().key !== "default";
}
